module.exports = __webpack_public_path__ + "img/space-ship.a7eb3c92.png";